import { Collapsible } from '../../Foundation';

export class CollapsibleOpen extends Collapsible {
   /**
   * @param {HTMLElement} element
   */
    constructor (element) {
        super(element);
        this._expanded = true
    }
}